export { generateTableHtml, tableHtmlWrapper } from './table'
export { generateDescriptionHtml } from './description'

// html转pdf实验网站地址：https://sandbox.openhtmltopdf.com/
// 直接使用上述地址，先检查html是否能够成功转为pdf文件，再调用后台结果获取文件
